import { useAtom } from "jotai";

import { videoPlayerAtom } from "@/constants/atoms";

import { StreamingIcons } from "../Icon";
import { IconButton } from "../IconButton";
import { SoundButtonProps } from "./types";

/**
 * Sound button for video player controls
 * Toggles sound mute/unmute state using consolidated videoPlayerAtom
 */
const SoundButton = ({ ariaLabel, className }: SoundButtonProps) => {
  const [videoPlayerState, setVideoPlayerState] = useAtom(videoPlayerAtom);

  const handleToggle = () => {
    const videoElement = videoPlayerState.videoRef?.current;
    if (videoElement) {
      videoElement.muted = !videoElement.muted;
      setVideoPlayerState((prev) => ({ ...prev, isMuted: videoElement.muted }));
    }
  };

  return (
    <IconButton
      icon={
        videoPlayerState.isMuted ? StreamingIcons.Mute : StreamingIcons.Volume
      }
      onClick={handleToggle}
      ariaLabel={ariaLabel || (videoPlayerState.isMuted ? "Unmute" : "Mute")}
      className={className}
    />
  );
};

export { SoundButton };
